<template>
  <v-container class="mt-n4">
    <v-row no-gutters>
      <v-col cols="12">
        <employee-claims-payment-bulkpay-card />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      EmployeeClaimsPaymentBulkpayCard: () => import('@/components/employee/claims/payment/BulkpayCard'),
    },
    metaInfo () {
      return {
        title: 'Claim Payment',        
      }
    },
  }
</script>
